// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypesWorkflowOutput } from './TypesWorkflowOutput';
import {
  TypesWorkflowOutputFromJSON,
  TypesWorkflowOutputFromJSONTyped,
  TypesWorkflowOutputToJSON,
  TypesWorkflowOutputToJSONTyped,
} from './TypesWorkflowOutput';
import type { DbOperationStatusType } from './DbOperationStatusType';
import {
  DbOperationStatusTypeFromJSON,
  DbOperationStatusTypeFromJSONTyped,
  DbOperationStatusTypeToJSON,
  DbOperationStatusTypeToJSONTyped,
} from './DbOperationStatusType';

/**
 *
 * @export
 * @interface HandlerOperationResponse
 */
export interface HandlerOperationResponse {
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  abortedBy?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  operationName?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  operationType?: string;
  /**
   *
   * @type {object}
   * @memberof HandlerOperationResponse
   */
  parameters?: object;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  requestedBy?: string;
  /**
   *
   * @type {DbOperationStatusType}
   * @memberof HandlerOperationResponse
   */
  status?: DbOperationStatusType;
  /**
   *
   * @type {Date}
   * @memberof HandlerOperationResponse
   */
  statusUpdatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof HandlerOperationResponse
   */
  traceUrl?: string;
  /**
   *
   * @type {Date}
   * @memberof HandlerOperationResponse
   */
  triggeredAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof HandlerOperationResponse
   */
  updatedAt?: Date;
  /**
   *
   * @type {TypesWorkflowOutput}
   * @memberof HandlerOperationResponse
   */
  workflowOutput?: TypesWorkflowOutput;
}

/**
 * Check if a given object implements the HandlerOperationResponse interface.
 */
export function instanceOfHandlerOperationResponse(
  value: object,
): value is HandlerOperationResponse {
  return true;
}

export function HandlerOperationResponseFromJSON(
  json: any,
): HandlerOperationResponse {
  return HandlerOperationResponseFromJSONTyped(json, false);
}

export function HandlerOperationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerOperationResponse {
  if (json == null) {
    return json;
  }
  return {
    abortedBy: json['aborted_by'] == null ? undefined : json['aborted_by'],
    id: json['id'] == null ? undefined : json['id'],
    operationName:
      json['operation_name'] == null ? undefined : json['operation_name'],
    operationType:
      json['operation_type'] == null ? undefined : json['operation_type'],
    parameters: json['parameters'] == null ? undefined : json['parameters'],
    requestedBy:
      json['requested_by'] == null ? undefined : json['requested_by'],
    status:
      json['status'] == null
        ? undefined
        : DbOperationStatusTypeFromJSON(json['status']),
    statusUpdatedAt:
      json['status_updated_at'] == null
        ? undefined
        : new Date(json['status_updated_at']),
    traceUrl: json['trace_url'] == null ? undefined : json['trace_url'],
    triggeredAt:
      json['triggered_at'] == null ? undefined : new Date(json['triggered_at']),
    updatedAt:
      json['updated_at'] == null ? undefined : new Date(json['updated_at']),
    workflowOutput:
      json['workflow_output'] == null
        ? undefined
        : TypesWorkflowOutputFromJSON(json['workflow_output']),
  };
}

export function HandlerOperationResponseToJSON(
  json: any,
): HandlerOperationResponse {
  return HandlerOperationResponseToJSONTyped(json, false);
}

export function HandlerOperationResponseToJSONTyped(
  value?: HandlerOperationResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aborted_by: value['abortedBy'],
    id: value['id'],
    operation_name: value['operationName'],
    operation_type: value['operationType'],
    parameters: value['parameters'],
    requested_by: value['requestedBy'],
    status: DbOperationStatusTypeToJSON(value['status']),
    status_updated_at:
      value['statusUpdatedAt'] == null
        ? undefined
        : value['statusUpdatedAt'].toISOString(),
    trace_url: value['traceUrl'],
    triggered_at:
      value['triggeredAt'] == null
        ? undefined
        : value['triggeredAt'].toISOString(),
    updated_at:
      value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    workflow_output: TypesWorkflowOutputToJSON(value['workflowOutput']),
  };
}
